// extracted by css-extract-rspack-plugin
var _1 = "Xgf8QZDd7UWhMayI";
var _2 = "GdKnAUBp3MROTvht";
var _3 = "Wkm3nRVjNto3MezV";
var _4 = "Xgf8QZDd7UWhMayI";
var _5 = "GdKnAUBp3MROTvht";
var _6 = "Wkm3nRVjNto3MezV";
var _7 = "ck1ihHIl6o0DKb34";
var _8 = "GISd3MgVC7M84eRV";
var _9 = "LIUG9ZEF8xAyzCwV";
var _a = "R33KbB65PCcusaoS";
var _b = "cuv37wjy2AA5PSb8";
var _c = "xmAvTrGXsREA72C7";
var _d = "HLRZrmDZQT8vohd3";
var _e = "Z06oA6BWyKA3gb2G";
var _f = "IpKPHlVE5M5LIlaT";
var _10 = "qDP0yaqOhVgjW7ZN";
var _11 = "HEityULSCAgMiKH9";
var _12 = "uYO88VBSHxsTNsEG";
var _13 = "wp9EEvhZ3ZE758jT";
var _14 = "f0zWnRWYUvAhpYdn";
var _15 = "yOcfKODZCRU7UjVs";
var _16 = "GO1ieONY0p6j9YL0";
var _17 = "tz3oZTQTajU5ph2F";
var _18 = "kJFktYkDUgmNR6AE";
var _19 = "ONbBok1BUUsCSFIM";
var _1a = "A6SSiwik_n8rGJqE";
var _1b = "ktsh4gyMxgTaWiFL";
var _1c = "uAPSdHNs5TA48LSi";
var _1d = "OhkcZEbZkLcT4smr";
var _1e = "EDmtNHK94ikjQKBy";
var _1f = "LKbBK4gM28cwvpqm";
var _20 = "f1yGaPxpqs06sW2L";
var _21 = "Nj_i1CRx78kZRgQi";
var _22 = "ck1ihHIl6o0DKb34";
var _23 = "GISd3MgVC7M84eRV";
var _24 = "LIUG9ZEF8xAyzCwV";
var _25 = "R33KbB65PCcusaoS";
var _26 = "cuv37wjy2AA5PSb8";
var _27 = "xmAvTrGXsREA72C7";
var _28 = "HLRZrmDZQT8vohd3";
var _29 = "Z06oA6BWyKA3gb2G";
var _2a = "IpKPHlVE5M5LIlaT";
var _2b = "qDP0yaqOhVgjW7ZN";
var _2c = "HEityULSCAgMiKH9";
var _2d = "uYO88VBSHxsTNsEG";
var _2e = "wp9EEvhZ3ZE758jT";
var _2f = "f0zWnRWYUvAhpYdn";
var _30 = "yOcfKODZCRU7UjVs";
var _31 = "GO1ieONY0p6j9YL0";
var _32 = "tz3oZTQTajU5ph2F";
var _33 = "kJFktYkDUgmNR6AE";
var _34 = "ONbBok1BUUsCSFIM";
var _35 = "A6SSiwik_n8rGJqE";
var _36 = "ktsh4gyMxgTaWiFL";
var _37 = "uAPSdHNs5TA48LSi";
var _38 = "OhkcZEbZkLcT4smr";
var _39 = "EDmtNHK94ikjQKBy";
var _3a = "LKbBK4gM28cwvpqm";
var _3b = "f1yGaPxpqs06sW2L";
var _3c = "Nj_i1CRx78kZRgQi";
export { _1 as "id-card--1", _2 as "id-card--2", _3 as "id-card--3", _4 as "idCard1", _5 as "idCard2", _6 as "idCard3", _7 as "ts-card--big", _8 as "ts-card--medium", _9 as "ts-card--photo", _a as "ts-card--placeholder", _b as "ts-card--squared", _c as "ts-card--video", _d as "ts-card--wide", _e as "ts-divider", _f as "ts-play-icon", _10 as "ts-player", _11 as "ts-player__country", _12 as "ts-player__country-name", _13 as "ts-player__divider", _14 as "ts-player__identifier", _15 as "ts-player__name", _16 as "ts-player__name__first-name", _17 as "ts-player__team", _18 as "ts-rank", _19 as "ts-rank__label", _1a as "ts-stats", _1b as "ts-stats__assists", _1c as "ts-stats__enhanced", _1d as "ts-stats__goals", _1e as "ts-stats__label", _1f as "ts-stats__minutes", _20 as "ts-stats__stat", _21 as "ts-stats__stat-goals", _22 as "tsCardBig", _23 as "tsCardMedium", _24 as "tsCardPhoto", _25 as "tsCardPlaceholder", _26 as "tsCardSquared", _27 as "tsCardVideo", _28 as "tsCardWide", _29 as "tsDivider", _2a as "tsPlayIcon", _2b as "tsPlayer", _2c as "tsPlayerCountry", _2d as "tsPlayerCountryName", _2e as "tsPlayerDivider", _2f as "tsPlayerIdentifier", _30 as "tsPlayerName", _31 as "tsPlayerNameFirstName", _32 as "tsPlayerTeam", _33 as "tsRank", _34 as "tsRankLabel", _35 as "tsStats", _36 as "tsStatsAssists", _37 as "tsStatsEnhanced", _38 as "tsStatsGoals", _39 as "tsStatsLabel", _3a as "tsStatsMinutes", _3b as "tsStatsStat", _3c as "tsStatsStatGoals" }
